import React, { useEffect, useState } from 'react'
import Modal from '../../components/master/Modal'
import { pexios, uploadImages } from '../../utils/functions';
import ImageZoom from '../../components/master/ImageZoom';
import { history, url } from '../../utils/variables';
import ImagePickerModal from '../../components/master/ImagePickerModal';
import { useSelector } from 'react-redux';
import addImage from '../../assets/images/AddImagePlaceholder/addImage.png';
import HeaderIcon from '../../assets/images/header-icon/camera.png'
import ImageBox from '../../components/master/ImageBox';
import { t } from 'i18next';

function Complete() {
    const [imgUid, setImgUid] = useState(null);
    const [attachments, setAttachments] = useState([]);
    const [loader,setLoader] = useState(false);
    const {id} = useSelector(store => store.routerData);
    const {accidentInfo,routerData} = useSelector(store => store);
    const images = attachments.filter(img=>img.filename.includes('cul_crash_image'));
    const coroukie_images = attachments.filter(itm => itm.filename.includes('coroukie_image'))
    useEffect(()=>{
        setLoader(true)
        pexios(`api/get_accident_photos/${id}`)
        .then((res)=>{
            setAttachments(res.data.attachments)
            setLoader(false)
        })
    },[id])
    function finishUpload(image, name, done) {
        uploadImages({
            id: id,
            type: 'accident',
            //name: `${user.type === 'expert' ? name : `crash_image${extraImagesCount}`}`,
            name :name,
            image,
            done,
            callback: (data) => {
                setAttachments(prevState => ([
                    ...prevState,
                    data,
                ]));
            },
        });
    }
  return (
    <div className='content image-complete'>
        <Modal visible={imgUid}>
            <div className='image-modal'>
                <i className='fas fa-times'
                    onClick={() => setImgUid(null)}
                />
                <ImageZoom imgUid={imgUid}/>
            </div>
        </Modal>
        {loader ?
            <Modal visible={loader}>
                <div className='loader-modal'>
                    <i className='fas fa-spinner fa-spin'/>
                </div>
            </Modal>
        :
        <>
        <div className='title-image'>
            <img src={HeaderIcon} alt="icon"/>
        </div>
        {/* only for bime hafez or iran */}
        {accidentInfo.has_coroukie && (routerData.insuranceCompanyId === 25 || routerData.insuranceCompanyId === 2) &&
        <>
        <p className='guide-text mx10 mt10'>تصاویر مربوط به گزارش پلیس(کروکی) تصادف را بارگذاری نمایید.
        </p>
        <div className='complete'>
            <div className='d-flex flex-row-reverse flex-wrap'>
                {coroukie_images.length > 0 && coroukie_images.map(itm=>(
                    <ImageBox
                        title={t('Police Report')}
                        name={`${itm.filename}`}
                        label='croukie_image'
                        attachments={attachments}
                        uploadDoc={finishUpload}
                    />
                ))}
                <ImageBox
                    title={t('Police Report')}
                    name={`coroukie_image${coroukie_images.length +1}`}
                    label='croukie_image'
                    attachments={attachments}
                    uploadDoc={finishUpload}
                />
            </div>
        </div>
        </>
        }
        <p className='guide-text mx10 mt10'>
          تصاویر تکمیلی حادثه شامل محل برخورد وسیله نقلیه، قسمت ها و قطعات آسیب دیده و همچنین تصویر کلی از تصادف را برای کارشناسی دقیق تر بارگذاری نمایید .  
        </p>
        <div className='box'>
        <div className='imageBox rtl'>
        {images.map(img=>(
            <div className='imageParent register-image-parent' key={img.id}>
                <img
                    onClick={() => setImgUid(img.uid)}
                    src={`${url}/files?uid=${img.uid}&width=200&height=200`}
                    alt='img'
                    id={img.id}
                />
            </div>
        ))}
        <div className='imageParent register-image-parent'>
            <ImagePickerModal
                renderBtn={<div className='add-image'><img src={addImage} alt='img'/></div>}
                upload={(image, done) => finishUpload(image,`cul_crash_image_${images.length +1}`, done)}
            />
                    {/* <p className='image-label cul'>
                        {t('Completment image')}
                    </p> */}
        </div>
        </div>
        </div>
        <div className='d-flex justify-center'>
            <button className='btn btn-circle btn-block btn-white-purple mt20 w-50' onClick={()=>history.push('/get_location')}>
                مرحله بعد
            </button>
        </div>
        </>
        }

    </div>
  )
}

export default Complete